<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">
            <!-- Header: My Accounts (Aligned Left) -->
            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                Transaction Details
            </div>
            <p v-if="errorMessages" class="text-red-500 text-center mb-4">{{ errorMessages }}</p>
            <div class="px-6 py-4 flex space-x-4">
                <button class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'bankstatement' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('bankstatement')">
                    Bank Statement
                </button>
                <button class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'customBankStatement' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('customBankStatement')">
                    From to To Statement
                </button>
            </div>

            <div class="bg-gray-200 px-6 py-3 rounded-t-lg">
                <div class="flex justify-between items-center">
                    <div class="w-full">
                        <div class="flex items-center mb-4 pb-2">
                            <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Account Number:</label>
                            <div class="rounded font-bold px-3 py-2">{{ bankStatement.account }}</div>
                        </div>

                        <div class="flex items-center mb-4 pb-2">
                            <label class="w-1/3 text-gray-700 font-bold text-right pr-4">{{ statementSource === 'loan' ? 'Outstanding Balance:' : 'Available Balance:' }}</label>
                            <div class="rounded font-bold px-3 py-2">{{ bankStatement.total_amount }}</div>
                        </div>
                    </div>

                    <div class="ml-8" v-if="statementSource === 'loan'">
                        <button @click="loanRepayment" class="px-6 py-2 text-white bg-primary text-sm font-medium rounded-md whitespace-nowrap hover:bg-blue-700">Loan Repayment</button>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'bankstatement'">
                <BankStatement :user="user" :bankStatement="bankStatement" />
            </div>
            <div v-else-if="activeTab === 'customBankStatement'">
                <CustomBankStatement :user="user" />
            </div>


        </div>
    </DashboardLayout>

</template>

<script>

import { apiRequest } from "@/api";
import DashboardLayout from "@/components/DashboardLayout.vue";
import BankStatement from "./BankStatement.vue";
import CustomBankStatement from "./CustomBankStatement.vue";

export default {
    name: 'MyProfile',
    components: {
        DashboardLayout, BankStatement, CustomBankStatement
    },
    data() {
        return {
            user: {},
            activeTab: 'bankstatement',
            bankStatement: {},
            statementSource : 'account',
            errorMessages: ''
        };
    },
    computed: {
        currentComponent() {
            return this.activeTab == 'bankstatement' ? 'BankStatement' : 'CustomBankStatement';
        }
    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);

        const storedBankStatement = sessionStorage.getItem("bankStatement");
        this.bankStatement = storedBankStatement ? JSON.parse(storedBankStatement) : {};

        this.statementSource = sessionStorage.getItem("statementSource") || 'account';

        if (this.$route.path === "/customBankStatement") this.activeTab = "customBankStatement";
        else this.activeTab = "bankstatement";
    },
    watch: {
        // Watch for URL changes and update the active tab
        "$route.path"() {
            this.updateTabFromRoute();
        }
    },
    methods: {
        async loanRepayment() {
            this.loading = true; 

            try {
                const response = await apiRequest('/balance', 'GET');

                if (response.data.status === 'success') {
                    sessionStorage.setItem('balances', JSON.stringify(response.data));
                    this.$router.push('/loanrepayment');
                }else {
                    this.showError(response.data.message);
                }
            } catch (error) {
                console.error("Error fetching bank accounts:", error);
            } finally {
                this.loading = false;
            }
        },
        showError(message) {
            this.errorMessages = message;
            if (this.errorTimeout) {
                clearTimeout(this.errorTimeout);
            }
            this.errorTimeout = setTimeout(() => {
                this.errorMessages = '';
            }, 3000);
        },
        navigateTo(tab) {
            this.activeTab = tab;
            const routes = {
                bankstatement: "/bankStatement",
                customBankStatement: "/customBankStatement",
            };
            this.$router.push(routes[tab]);
        },
        updateTabFromRoute() {
            if (this.$route.path === "/customBankStatement") {
                this.activeTab = "customBankStatement";
            } else {
                this.activeTab = "bankstatement";
            }
        }
    }
}

</script>
